module.exports = __webpack_public_path__ + "img/16l007-02.d1455e2f.png";